__turbopack_context__.v({
  "button": "_tLana_button",
  "controls": "_tLana_controls",
  "paddingBottom0": "_tLana_paddingBottom0",
  "paddingBottom112": "_tLana_paddingBottom112",
  "paddingBottom128": "_tLana_paddingBottom128",
  "paddingBottom16": "_tLana_paddingBottom16",
  "paddingBottom32": "_tLana_paddingBottom32",
  "paddingBottom48": "_tLana_paddingBottom48",
  "paddingBottom64": "_tLana_paddingBottom64",
  "paddingBottom80": "_tLana_paddingBottom80",
  "paddingBottom96": "_tLana_paddingBottom96",
  "paddingTop0": "_tLana_paddingTop0",
  "paddingTop112": "_tLana_paddingTop112",
  "paddingTop128": "_tLana_paddingTop128",
  "paddingTop16": "_tLana_paddingTop16",
  "paddingTop32": "_tLana_paddingTop32",
  "paddingTop48": "_tLana_paddingTop48",
  "paddingTop64": "_tLana_paddingTop64",
  "paddingTop80": "_tLana_paddingTop80",
  "paddingTop96": "_tLana_paddingTop96",
  "questionnaire": "_tLana_questionnaire",
});
